module.exports = __webpack_public_path__ + "img/home_slide5.90021357.jpg";